import { AppMeta } from '../Screens/MyAppsScreen/MyAppsScreen.types';

// Hub metadata per app (non-text where possible). Keyed by slug.
// Adding a new app = add its entry here + its object in appsData.ts.
export const appsMeta: Record<string, AppMeta> = {
  gazella: {
    platforms: ['ios', 'android'],
    status: 'offline',
    category: 'sports',
    tech: ['React Native', 'Expo', 'TypeScript'],
    version: '2.1.0',
    accent: 'linear-gradient(135deg, #f5c2a7 0%, #f38ba8 100%)',
  },
  youtime: {
    platforms: ['android', 'ios'],
    status: 'live',
    category: 'utility',
    tech: ['React Native', 'TypeScript'],
    version: '1.2.0',
    accent: 'linear-gradient(135deg, #89b4fa 0%, #94e2d5 100%)',
  },
  'festivos-del-mundo': {
    platforms: ['ios', 'android'],
    status: 'live',
    category: 'utility',
    tech: ['React Native', 'Expo', 'TypeScript'],
    version: '1.5.0',
    accent: 'linear-gradient(135deg, #a6e3a1 0%, #94e2d5 100%)',
  },
  taskmaster: {
    platforms: ['ios', 'android'],
    status: 'live',
    category: 'productivity',
    tech: ['React Native', 'Expo', 'TypeScript', 'Node'],
    version: '3.5.0',
    accent: 'linear-gradient(135deg, #f9e2af 0%, #f5c2a7 100%)',
  },
  pronostigol: {
    platforms: ['ios', 'android'],
    status: 'offline',
    category: 'sports',
    tech: ['React Native', 'TypeScript', 'Node'],
    version: '1.0.0',
    accent: 'linear-gradient(135deg, #cba6f7 0%, #b4befe 100%)',
  },
  superlineup: {
    platforms: ['android', 'ios'],
    status: 'live',
    category: 'sports',
    tech: ['React Native', 'TypeScript'],
    accent: 'linear-gradient(135deg, #89b4fa 0%, #74c7ec 100%)',
  },
  'football-cup-simulator': {
    platforms: ['android', 'ios'],
    status: 'live',
    category: 'sports',
    tech: ['React Native', 'TypeScript', 'Zustand'],
    version: '4.0.1',
    accent: 'linear-gradient(135deg, #a6e3a1 0%, #89b4fa 100%)',
    featured: true,
    // Las cifras van en la ficha de la app de la que salen, no en el hero:
    // sueltas arriba parecian del portfolio entero.
    reachKey: 'apps.reach.footballCupSimulator',
  },
  'encuentra-tu-mascota': {
    platforms: ['web'],
    status: 'live',
    category: 'utility',
    tech: ['React', 'TypeScript', 'Vite', 'Node'],
    version: '0.7.0',
    webUrl: 'https://www.encuentra-tu-mascota.com/',
    accent: 'linear-gradient(135deg, #a6e3a1 0%, #f9e2af 100%)',
    featured: true,
  },
  'my-link-hub': {
    platforms: ['web'],
    status: 'live',
    category: 'productivity',
    tech: ['React', 'TypeScript'],
    webUrl: 'https://www.my-link-hub.com',
    accent: 'linear-gradient(135deg, #89b4fa 0%, #b4befe 100%)',
  },
  splitio: {
    platforms: ['web'],
    status: 'live',
    category: 'utility',
    tech: ['React', 'TypeScript', 'Vite', 'Node'],
    version: '0.10.2',
    webUrl: 'https://www.splitio.net/',
    accent: 'linear-gradient(135deg, #8b7cf6 0%, #74c7ec 100%)',
  },
  'mis-pagos': {
    platforms: ['web'],
    status: 'live',
    category: 'utility',
    tech: ['Next.js', 'React', 'TypeScript', 'Node'],
    version: '0.1.50',
    webUrl: 'https://www.mispagos.co/',
    accent: 'linear-gradient(135deg, #cba6f7 0%, #f38ba8 100%)',
    featured: true,
  },
  habitflow: {
    platforms: ['ios', 'android'],
    status: 'live',
    category: 'productivity',
    tech: ['React Native', 'TypeScript'],
    version: '1.0.0',
    accent: 'linear-gradient(135deg, #f5c2a7 0%, #fab387 100%)',
  },
  'trainflow-ai': {
    platforms: ['ios', 'android'],
    status: 'live',
    category: 'sports',
    tech: ['React Native', 'TypeScript', 'RevenueCat'],
    version: '1.0.0',
    accent: 'linear-gradient(135deg, #e07a5f 0%, #f2a488 100%)',
  },
  'cop-moneda-colombiana': {
    platforms: ['android', 'ios'],
    status: 'live',
    category: 'utility',
    tech: ['React Native', 'TypeScript', 'AdMob'],
    version: '0.1.0',
    accent: 'linear-gradient(135deg, #f9e2af 0%, #89b4fa 100%)',
  },
  'player-radar': {
    platforms: ['android'],
    status: 'live',
    category: 'sports',
    tech: ['React Native', 'TypeScript', 'RevenueCat'],
    version: '1.0.0',
    accent: 'linear-gradient(135deg, #a6e3a1 0%, #74c7ec 100%)',
  },
  'agenda-pilates': {
    platforms: ['web'],
    status: 'live',
    category: 'productivity',
    tech: ['React', 'TypeScript', 'Vite', 'React Native', 'Node'],
    version: '0.99.35',
    webUrl: 'https://www.agendapilates.com/landing',
    accent: 'linear-gradient(135deg, #a6e3a1 0%, #f5c2a7 100%)',
  },
  'presidente-simulator': {
    // Sin webUrl todavia: el repo esta publicado pero la app de Amplify aun no
    // existe, y anunciar un enlace que no abre es peor que decir "pronto".
    platforms: ['web'],
    status: 'soon',
    category: 'entertainment',
    tech: ['React', 'TypeScript', 'Vite', 'Zustand'],
    version: '0.2.0',
    accent: 'linear-gradient(135deg, #f9e2af 0%, #fab387 100%)',
  },
};
